/* eslint-disable @typescript-eslint/camelcase */

import uaParser from 'ua-parser-js';
import { CommonAttributes } from '@italist/grpc-proto/services/guardian_pb';

const searchEngine = referrer => {
  if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
    return 'google';
  }
  if (referrer.search('https?://(.*)bing.com') === 0) {
    return 'bing';
  }
  if (referrer.search('https?://(.*)yahoo.com') === 0) {
    return 'yahoo';
  }
  if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
    return 'duckduckgo';
  }
  return null;
};

export const getClientInfo = (): Partial<CommonAttributes.AsObject> => {
  const queryParamsStr = window.location.search;
  const urlParams = new URLSearchParams(queryParamsStr);
  const referrer = document.referrer || '';
  const parsedUa = uaParser(window.navigator.userAgent);
  return {
    browser: parsedUa.browser.name,
    browserVersion: parsedUa.browser.major,
    currentUrl: window.location.href,
    device: parsedUa.device.model,
    os: `${parsedUa.os.name} ${parsedUa.os.version}`,
    referrer,
    referringDomain: referrer ? new URL(referrer).hostname : '',
    screenHeight: window.screen.height.toString(),
    screenWidth: window.screen.width.toString(),
    searchEngine: searchEngine(referrer),
    utmCampaign: urlParams.get('utm_campaign'),
    utmContent: urlParams.get('utm_content'),
    utmMedium: urlParams.get('utm_medium'),
    utmSource: urlParams.get('utm_source'),
  };
};
